const PRESETS = [
  { label: "< 1400",    min: "",   max: 1399 },
  { label: "1400–1600", min: 1400, max: 1600 },
  { label: "1600–1800", min: 1600, max: 1800 },
  { label: "1800–2000", min: 1800, max: 2000 },
  { label: "2000+",     min: 2000, max: ""   },
];

const PAGE_SIZES = [10, 20, 50];

function RatingFilter({
  minRating,
  maxRating,
  setMinRating,
  setMaxRating,
  limit,
  setLimit,
}) {
  const activePreset = PRESETS.find(
    (p) => String(p.min) === String(minRating) && String(p.max) === String(maxRating)
  );

  return (
    <div className="space-y-4">

      {/* header */}
      <p className="text-xs text-gray-500 uppercase tracking-widest font-medium">
        Rating Range
      </p>

      {/* presets on the left, manual controls pushed to the right on wide
          screens so the row's width is actually used instead of leaving
          a dead gap */}
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">

        {/* presets */}
        <div className="flex flex-wrap gap-2">
          {PRESETS.map((preset) => {
            const isActive = activePreset === preset;
            return (
              <button
                key={preset.label}
                onClick={() => { setMinRating(preset.min); setMaxRating(preset.max); }}
                className={`px-3 py-1.5 rounded-lg text-xs font-medium border transition-all duration-200 cursor-pointer
                  ${isActive
                    ? "bg-blue-500/20 border-blue-500/50 text-blue-300"
                    : "border-white/10 text-gray-400 hover:border-white/20 hover:text-gray-300"
                  }`}
              >
                {preset.label}
              </button>
            );
          })}
        </div>

        {/* manual inputs + per-page */}
        <div className="flex flex-wrap items-end gap-4 lg:gap-6">

          {/* min – max */}
          <div className="flex items-center gap-2">
            <div className="flex flex-col">
              <span className="text-[10px] text-gray-600 mb-1">Min</span>
              <input
                type="number"
                value={minRating}
                onChange={(e) => setMinRating(e.target.value)}
                placeholder="1200"
                className="px-2.5 py-1.5 w-20 text-xs text-gray-300
                           bg-white/5 border border-white/10 rounded-lg
                           outline-none focus:ring-1 focus:ring-blue-500/30"
              />
            </div>
            <span className="text-gray-600 text-xs mt-3">–</span>
            <div className="flex flex-col">
              <span className="text-[10px] text-gray-600 mb-1">Max</span>
              <input
                type="number"
                value={maxRating}
                onChange={(e) => setMaxRating(e.target.value)}
                placeholder="2000"
                className="px-2.5 py-1.5 w-20 text-xs text-gray-300
                           bg-white/5 border border-white/10 rounded-lg
                           outline-none focus:ring-1 focus:ring-blue-500/30"
              />
            </div>
          </div>

          {/* divider — only visible once the two groups sit side by side */}
          <div className="hidden lg:block h-8 w-px bg-white/10" />

          {/* per-page toggle */}
          <div className="flex flex-col">
            <span className="text-[10px] text-gray-600 mb-1">Per page</span>
            <div className="flex rounded-lg overflow-hidden border border-white/10">
              {PAGE_SIZES.map((size) => (
                <button
                  key={size}
                  onClick={() => setLimit(size)}
                  className={`px-3 py-1.5 text-xs transition-all duration-150 cursor-pointer
                    ${String(limit) === String(size)
                      ? "bg-blue-500/20 text-blue-300"
                      : "text-gray-500 hover:text-gray-300 hover:bg-white/5"
                    }`}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default RatingFilter;
